import type { SxStyle } from '@aibees/shared/theme';

export const checkIcon: SxStyle = {
  color: 'primary.500',
  fontSize: 22,
};

export const comingSoonChip: SxStyle = {
  backgroundColor: (p) => p.palette.grey[300],
  color: (p) => p.palette.grey[700],
  fontWeight: 500,
  height: 32,
};
